import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';
import {CardSessaoLinhaSuperiorComponent} from '../card-sessao-linha-superior/card-sessao-linha-superior.component';
import {DatePipe} from '@angular/common';
import {CelularMaskPipe} from '../../../../shared/pipe/celular-mask.pipe';
import {environment} from '../../../../../../environments/environment';
import {AuthService} from '../../../../shared/service/auth.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-card-sessao-tablet',
  standalone: true,
  imports: [
    CardSessaoLinhaSuperiorComponent,
    DatePipe,
    CelularMaskPipe
  ],
  templateUrl: './card-sessao-tablet.component.html',
  styleUrl: './card-sessao-tablet.component.css'
})
export class CardSessaoTabletComponent {

  @Input() sessao?: Sessao
  @Input() isExibicao = false;

  @Output() exibirDetalhes = new EventEmitter<Sessao>();
  @Output() modalChat = new EventEmitter<Sessao>();
  @Output() exibirEdicaoDetalhes = new EventEmitter<Sessao>();
  @Output() reiniciarSessao = new EventEmitter<Sessao>();

  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);

  abrirModalDetalhes(){
    this.exibirDetalhes.emit(this.sessao);
  }
  abrirModalChat(){
    this.modalChat.emit(this.sessao);
  }
  abrirModalEdicaoDetalhes(){
    this.exibirEdicaoDetalhes.emit(this.sessao);
  }
  abrirModalReiniciarSessao(){
    this.reiniciarSessao.emit(this.sessao);
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

}
